var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 24C20.8211 24 22.5 22.3211 22.5 20.25C22.5 18.1789 20.8211 16.5 18.75 16.5C16.6789 16.5 15 18.1789 15 20.25C15 22.3211 16.6789 24 18.75 24Z",
    stroke: "#6921C4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5909 10.4999H7.5C6.70435 10.4999 5.94129 10.816 5.37868 11.3786C4.81607 11.9412 4.5 12.7043 4.5 13.4999V26.9999C4.5 27.7956 4.81607 28.5587 5.37868 29.1213C5.94129 29.6839 6.70435 29.9999 7.5 29.9999H28.5C29.2957 29.9999 30.0587 29.6839 30.6213 29.1213C31.1839 28.5587 31.5 27.7956 31.5 26.9999V16.4999",
    stroke: "#6921C4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.99994H31.5",
    stroke: "#6921C4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 4.49997V13.5",
    stroke: "#6921C4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraupload);
export default __webpack_public_path__ + "static/media/cameraupload.3b8262a0.svg";
export { ForwardRef as ReactComponent };